import BaseFileData from "./base-file-data.ts";

class FileData3D extends BaseFileData {

}

export default FileData3D;